module.exports = __webpack_public_path__ + "fonts/5bda271.ttf";